<template>
  <div class="search-modal">
    <SearchForm
      class="search-modal__form"
      :is-open="isOpen"
      :game-page="gamePage"
      @input="v => searchValue = v"
      @close="$emit('close')"
      @open="$emit('open')"
    >
      <template #trigger>
        <slot name="trigger" />
      </template>
    </SearchForm>

    <Transition name="accordion">
      <SearchModalContent
        v-if="isOpen"
        :is-open="isOpen"
        :search-value="searchValue"
        :game-page="gamePage"
      />
    </Transition>
  </div>
</template>

<script>
import SearchForm from '@/components/Lobby/SearchModal/SearchForm'
import SearchModalContent from '@/components/Lobby/SearchModal/SearchModalContent'

export default {
  name: 'SearchModal',
  components: {
    SearchForm,
    SearchModalContent,
  },
  props: {
    isOpen: { type: Boolean },
    gamePage: { type: Boolean },
  },
  data() {
    return {
      searchValue: '',
    }
  },
  watch: {
    '$route.path'() {
      this.$emit('close')
    },
  },
  beforeDestroy() {
    this.$emit('close')
  },
}
</script>

<style lang="scss" scoped>
.search-modal {
  width: 100%;
}

.accordion-enter-active,
.accordion-leave-active {
  transition: max-height 0.5s linear;
  max-height: 100vh;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  max-height: 0;
  transition: max-height 0.5s;
  overflow: hidden;
}
</style>
